export default __webpack_public_path__ + "static/media/003-tornado.ba27a223.svg";